import { Building2, Vote, Trophy } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const WESTLANDS =
  "https://images.unsplash.com/photo-1741991110666-88115e724741?crop=entropy&cs=srgb&fm=jpg&q=85";

const STATS = [
  { icon: Vote, n: "3 terms", l: "Mandates from Westlands voters — 2013, 2017, 2022" },
  { icon: Building2, n: "5 wards", l: "Highridge, Parklands, Karura, Kangemi & Mountain View served" },
  { icon: Trophy, n: "Top rated", l: "Recognized among Nairobi's best NG-CDF managers" },
];

export const County = () => (
  <section id="westlands" data-testid="county-section" className="py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="eyebrow mb-4" data-testid="county-eyebrow">County Legacy</p>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              Westlands, Nairobi. <span className="text-orange-500">His proving ground.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 text-base sm:text-lg text-stone-400 leading-relaxed">
              Westlands is one of Nairobi's most diverse and fastest-changing
              counties — corporate towers beside informal settlements. Under
              Wanyonyi's watch, bursary programmes, ICT hubs for youth, market
              upgrades and micro-business grants have reached every ward, building a
              county model he now wants to scale to an entire county.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 space-y-5">
              {STATS.map((s) => (
                <div
                  key={s.n}
                  data-testid={`county-stat-${s.n.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="flex items-start gap-5 border-l border-white/10 pl-6"
                >
                  <s.icon size={20} className="text-orange-500 mt-1 shrink-0" />
                  <div>
                    <p className="font-display font-bold text-xl text-stone-100">{s.n}</p>
                    <p className="text-sm text-stone-500 mt-1 leading-relaxed">{s.l}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal className="spotlight-frame" data-testid="county-image-frame">
          <img
            src={WESTLANDS}
            alt="Westlands, Nairobi — urban skyline"
            className="w-full h-[420px] sm:h-[560px] object-cover max-h-[80vh]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10]/85 via-transparent to-transparent" />
          <div className="absolute bottom-0 inset-x-0 p-6">
            <p className="mono text-[11px] tracking-[0.25em] uppercase text-orange-400">
              Westlands · Nairobi
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
